
import { Component, Prop, Vue } from 'vue-property-decorator'
import * as qiniu from 'qiniu-js'
import { FileService } from '@/services/index'

@Component({
    name: 'UploadImg'
})
export default class extends Vue {
    @Prop({ required: true }) private uploadCallback!: Function

    private onUploadImg() {
        (this.$refs.uploadInput as any).click()
    }

    private uploadChange(e: any) {
        const files = e.target.files
        const $uploadInput = this.$refs.uploadInput as any
        if (!files) return
        this.uploadFiles(files)
        $uploadInput.value = null
    }

    private uploadFiles(files: any) {
        let postFiles = Array.prototype.slice.call(files)
        let _this = this
        
        postFiles = postFiles.slice(0, 1)
        if (postFiles.length === 0) return

        postFiles.forEach(function(file: any) {
            _this.uploadQiqiu(file)
        })
    }

    private async uploadQiqiu(file: any) {
        const index = file.name.lastIndexOf('.')
        const fileType = file.name.substr(index + 1)
        const size = file.size / 1024
        const _this = this
        
        if (['png', 'jpg', 'jpeg', 'gif'].indexOf(fileType.toLowerCase()) === -1) {
            this.$message.error('请上传 png、jpeg、jpg 格式图片')
            return
        }
        if (size / 1024 > 5) {
            this.$message.error('图片不能大于 5mb，请重新选择图片')
            return
        }

        const config: any = {
            useCdnDomain: false,   //表示是否使用 cdn 加速域名
            region: null           //选择上传域名区域；当为 null 或 undefined 时，自动分析上传域名区域
        }
        const putExtra: any = {
            fname: '',   // string，文件原文件名
            params: {},  //object，用来放置自定义变量
            mimeType: ['image/png', 'image/jpeg', 'image/gif'] || null   //用来限制上传文件类型，为 null 时表示不对文件类型限制；限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
        }
        const subObject: any = { 
            error: function() {
                _this.$message.error('上传文件失败，请重新上传')
            },
            complete: function(result: any) {
                const url = result.key
                _this.uploadCallback(url)
            }
        }

        const result = await FileService.getToken()
        if (result.status === 200) {
            const token = result.data.token
            const key = result.data.key
            const observable = qiniu.upload(file, key, token, putExtra, config)
            observable.subscribe(subObject)
        }
        
    }
}
